import Parse from 'parse';

import { getDocumentById } from 'src/apis/docsAPI';

const CONVERT_ESTIMATE_TO_INVOICE_CLOUD_FUNCTION_NAME = 'convertEstimateToInvoice';

interface CloudConvertResult {
  invoiceRemoteId: string;
  invoiceObjectId: string;
  invoiceNo: string;
}

/**
 * Calls the `convertEstimateToInvoice` Parse cloud function (IS-11822) and
 * returns the created invoice as a Parse.Object, so callers keep the same
 * return contract as the legacy local build.
 *
 * Runs under the logged-in user's session (no master key / accountId), so the
 * server infers the account from the session.
 */
export const convertEstimateToInvoiceViaCloud = async (
  estimateRemoteId: string
): Promise<Parse.Object> => {
  const result: CloudConvertResult = await Parse.Cloud.run(
    CONVERT_ESTIMATE_TO_INVOICE_CLOUD_FUNCTION_NAME,
    {
      estimateRemoteId
    }
  );

  return getDocumentById(result.invoiceObjectId);
};
